import { ISearchParams } from 'interfaces'
import { Key } from 'react'
import { apiClientService, dateService, transformerService } from '.'

const BASE_RESIDENCE_URL = 'Strutture/'

function getResidence(strutturaId: Key, setSuccess: (data: any) => void, setError?: (error: string) => void, searchParams?: ISearchParams) {
  return apiClientService.baseApiCall(
    BASE_RESIDENCE_URL + strutturaId,
    'get',
    transformerService.fromISearchParamstoIBESearchParams(searchParams),
    undefined,
    setSuccess,
    (error) => !!setError && setError(error),
  )
}

const search = (searchParams: ISearchParams, setSuccess: (data: any) => void, setError?: (error: string) => void) => {
  return apiClientService.baseApiCall(
    BASE_RESIDENCE_URL + 'GetStrutture',
    'get',
    transformerService.fromISearchParamstoIBESearchParams(searchParams),
    undefined,
    (res) => {
      setSuccess(res)
    },
    (error) => setError && setError(error),
  )
}

const getDefaultSearchParams = () => {
  const { from: defaultFrom, to: defaultTo } = dateService.getDefaultDatesRange()
  return {
    dateFrom: defaultFrom,
    dateTo: defaultTo,
    guestsPerRoom: [1],
    profileTypeId: 'C',
  }
}

export const residenceService = {
  getDefaultSearchParams,
  getResidence,
  search,
}
